<div class="groups-shops-create component-container component-page-container action-button-wrapper"
     fxLayout="column"
     fxLayoutGap="2%"
>
    <div class="bottom-action-mg groups-shops-create-form-container">
        <custom-panel header="Nowa cecha" [areButtons]="false" class="flex flex-grow">
            <div panel-body>
                <form [formGroup]="creatingForm" (ngSubmit)="onSubmit()">
                    <div fxLayout="row" fxLayoutGap="20px">
                        <mat-form-field fxFlex="auto">
                            <label>
                                <input matInput placeholder="Nazwa cechy" formControlName="name" required>
                            </label>
                        </mat-form-field>

                        <mat-form-field fxFlex="auto">
                            <mat-label>Rodzaj</mat-label>
                            <mat-select formControlName="type" (ngModelChange)="changeType()">
                                <mat-option *ngFor="let type of types" [value]="type">
                                    {{type}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button #submitButton type="submit" style="display: none;"></button>
                    </div>
                    <div class="set-select-option" *ngIf="creatingForm.get('type').value === 'Select'">
                        <p class="sim-step-hint pv-xs" fxLayout="row" fxLayoutAlign="flex-start center">
                            <mat-icon class="pr-xxs text-green">info</mat-icon>
                            <span class="upper text-green pr-xxs">podpowiedź:</span>
                            Dodaj opcje które będą widoczne w polu typu Select
                        </p>
                        <div fxLayout="column">
                            <div
                                class="select-field"
                                *ngFor="let field of this.creatingForm.get('possibleValues')['controls']; let i = index"
                                fxLayout="column"
                                formArrayName="possibleValues"
                            >
                                <div fxFlex="auto" [formGroupName]="i">
                                    <mat-form-field fxFlex="auto">
                                        <label>
                                            <input matInput placeholder="Wartość pola*" formControlName="name">
                                        </label>
                                    </mat-form-field>
                                    <div class="actions" fxFlex="none" fxLayout="row">
                                        <button type="button" mat-icon-button fxFlex="none" aria-label="Dodaj nowe pole" (click)="addField()">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                        <button
                                            type="button"
                                            mat-icon-button
                                            fxFlex="none"
                                            aria-label="Skasuj pole"
                                            [disabled]="this.creatingForm.value.possibleValues.length === 1"
                                            (click)="removeField(field.id)"
                                        >
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="mb-xs mt--xxs">
                                    <div
                                        class="mat-error mat-small"
                                        *ngIf="field.controls['name'].errors && field.controls['name'].errors['duplicated']"
                                        fxFlex="none"
                                        fxLayout="column"
                                    >
                                        Wartości pól nie mogą się powtarzać
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </custom-panel>
    </div>
</div>

<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row"
         fxLayoutGap="1%" fxLayoutAlign="flex-end center"
    >
        <button-spinner class="ml-xxs" [inProgress]="isSaving" diameter="20">
        </button-spinner>
        <button
            type="button"
            class="upper action-button butt-back action-button-icon"
            (click)="navigationBack()"
        >
            <p class="upper">wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button
            type="button"
            (click)="submitButton.click()"
            [disabled]="isSaving"
            class="upper action-button butt-primary action-button-icon"
        >
            <p class="upper">zapisz</p>
            <mat-icon class="action-icon">save_alt</mat-icon>
        </button>
    </div>
</div>
